export default __webpack_public_path__ + "static/media/icon_back_screen.59393c06.svg";